import React, { useEffect, useState } from 'react'
import Stepper from 'react-stepper-horizontal'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Link, useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const Card1 = () => {
  toast.configure()
  const params = useParams()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  const user = localStorage.getItem('user')
  const token = localStorage.getItem('token')
  const [round, setRound] = useState('')
  const [firstPhone, setFirstPhone] = useState('')
  const [secondPhone, setSecondPhone] = useState('')
  const [contact, setContact] = useState('')
  const [values, setValues] = useState()

  // get personal details of candidate
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchFormData',

        {
          id: params.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setValues(res.data.currentRoundData[0])
        setContact(res.data.currentRoundData[0].contact)
        setRound(res.data.currentRoundData[0].interview_round)
        setFirstPhone(res.data.currentRoundData[0].reference1_contact)
        setSecondPhone(res.data.currentRoundData[0].reference2_contact)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // onchage func of input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  // update personal details of candidate
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'referral/updateReferralDetails',

        {
          id: params.id,
          email: values.email,
          current_location: values.current_location,
          permanent_place: values.permanent_place,
          applied_date: values.applied_date,
          interviewer_name: values.interviewer_name,
          interview_round: values.interview_round,
          interview_date: values.interview_date,
          interview_time: values.interview_time,
          interview_feedback: values.interview_feedback,
          remarks_hr: values.remarks_hr,
          status_hr: values.status_hr,
          final_status: values.final_status,
          relocate_to_ahmedabad: values.relocate_to_ahmedabad,
          other_offer_on_hand: values.other_offer_on_hand,
          joinig_date: values.joinig_date,
          offered_salary: values.offered_salary,
          offered_bonus: values.offered_bonus,
          final_remarks: values.final_remarks,
          candidate_resume: values.candidate_resume,
          candidate_name: values.candidate_name,
          candidate_linkedin: values.candidate_linkedin,
          contact: contact,
          current_ctc: values.current_ctc,
          expected_ctc: values.expected_ctc,
          designation: values.designation,
          relevant_it_experience: values.relevant_it_experience,
          current_organisation: values.current_organisation,
          notice_period: values.notice_period,
          reason_for_job_change: values.reason_for_job_change,
          reference1_contact: firstPhone,
          reference1_name: values.reference1_name,
          reference2_contact: secondPhone,
          reference2_name: values.reference2_name,
          modifierEmail: user,
          nextRoundEmailStatus: false,
          eligible_for_next_round:
            values.eligible_for_next_round === '' ||
            values.eligible_for_next_round === null
              ? 'NA'
              : values.eligible_for_next_round,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success('personal information updated successfully', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (err.response.status === 401) {
          logout()
        }
      })
  }
  return (
    <>
      <div className=" mt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/home" className="link text-primary">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item ">
              {' '}
              <Link to="/referral" className="link text-primary">
                Referral Applications
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {values ? values.candidate_name : ''}
            </li>
          </ol>
        </nav>
      </div>
      <div>
        <div>
          <Stepper
            steps={[
              { title: 'Round 1' },
              { title: 'Round 2' },
              { title: 'Round 3' },
            ]}
            activeStep={round.substring(6, 7) - 1}
          />
        </div>
        <form onSubmit={postData}>
          <div className="card mt-4 p-4 applicantCard">
            {values ? (
              <div className="row g-2">
                <h5 className="mb-4 text-primary">Personal Informations</h5>
                <div className="col-md ">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Name"
                      name="candidate_name"
                      defaultValue={values.candidate_name}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Name</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="email"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Email address"
                      name="email"
                      defaultValue={values.email}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Email address</label>
                  </div>

                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={contact}
                      onChange={setContact}
                      enableSearch
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Current Location"
                      name="current_location"
                      defaultValue={values.current_location}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Current Location</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Permanent/Native Location"
                      name="permanent_place"
                      defaultValue={values.permanent_place}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Permanent/Native Location
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Position"
                      name="designation"
                      defaultValue={values.designation}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Position</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Relevant Experience in the industry"
                      name="relevant_it_experience"
                      defaultValue={values.relevant_it_experience}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Relevant Experience in the industry
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Current Organization"
                      name="current_organisation"
                      defaultValue={values.current_organisation}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Current Organization
                    </label>
                  </div>
                </div>
                <div className="col-md ">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Notice Period"
                      name="notice_period"
                      defaultValue={values.notice_period}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Notice Period</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Reason for job Change"
                      name="reason_for_job_change"
                      defaultValue={values.reason_for_job_change}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Reason for job Change
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="number"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Current CTC In LPA"
                      name="current_ctc"
                      step="0.0001"
                      defaultValue={values.current_ctc}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Current CTC In LPA
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="number"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Expected CTC In LPA"
                      name="expected_ctc"
                      step="0.0001"
                      defaultValue={values.expected_ctc}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Expected CTC In LPA
                    </label>
                  </div>

                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="First Reference Name and Contact"
                      name="reference1_name"
                      defaultValue={values.reference1_name}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      First Reference Name and Contact
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={firstPhone}
                      onChange={setFirstPhone}
                      enableSearch
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      placeholder="Second Reference Name and Contact"
                      name="reference2_name"
                      defaultValue={values.reference2_name}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Second Reference Name and Contact
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={secondPhone}
                      enableSearch
                      onChange={setSecondPhone}
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button className="btn btn-primary" type="submit">
                      Update
                    </button>
                    {values.candidate_linkedin === '' ? (
                      <button
                        type="button"
                        className="btn btn-outline-primary disabled"
                      >
                        View Linkedin Profile
                      </button>
                    ) : (
                      <a
                        href={values.candidate_linkedin}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                        >
                          View Linkedin Profile
                        </button>
                      </a>
                    )}
                    <a
                      href={values.candidate_resume}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button type="button" className="btn btn-outline-primary">
                        View Resume
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </form>
      </div>
    </>
  )
}
